//공통 상수를 정의 함.

const Constants = {
  COUNTRY: "대한민국",

  //공통 메시지 창에서 사용하는 Config관련 메시지 창 상수
  MSG_ALERT: "01", // 알림창 default
  MSG_COMFIRM: "02", // 확인창

  //공통 메시지 창에서 사용하는 Config관련 메시지 버튼 타입 상수
  BTN_TP_OK: "01", // 확인
  BTN_TP_OKCANCEL: "02", // 확인 / 취소
  BTN_TP_YESNO: "03", // 예 / 아니오
  BTN_TP_CUSTOM: "04", // 커스텀 버튼

  BTN_KND_NONE: "", //없음
  BTN_KND_OK: "01", //확인
  BTN_KND_CANCEL: "02", //취소
  BTN_KND_YES: "03", //예
  BTN_KND_NO: "04", //아니오

  //세션스토에 저장시 키값 목록
  STORE_KEY_CONNKEY: "CONNKEY", //인입 시 접속 키값.
  STORE_KEY_CONNINFO: "CONNINFO", //고객정보 키값.
  STORE_KEY_USER: "USER", //로그인 정보 키값.
  STORE_KEY_MENUDATA: "MENU_DATA", //메뉴데이터 키값.
  STORE_KEY_PGMDATA: "PROGRAM_DATA", //프로그램데이터 키값.
  STORE_KEY_AUTHNEXT: "AUTH_SUCCESS_DATA", //인증성공시 이동위치

  //로그레벨 1 : error 2 : warning 3 : log 4: debug
  LOG_LEVEL_ERROR: 1,
  LOG_LEVEL_WARN: 2,
  LOG_LEVEL_INFO: 3,
  LOG_LEVEL_DEBUG: 4,

  SMS_AUTH_STEP1: 1, //휴대폰인증 단계 1
  SMS_AUTH_STEP2: 2, //휴대폰인증 단계 2

  BIRTH_SIZE: 6, //생년월일자릿수
  SMS_AUTH_NUM_SIZE: 6, //인증번호자릿수
  IVR_PWD_SIZE: 4, //IVR 비밀번호 자릿수

  GUIDE_NAME: "itgnAplyManual_v1.pdf", //통합신청 신청매뉴얼 명

  TERM_DBTRRPROBJT: 12, //채무자신고기간여부 12월

  ACT_VARS: "VARS", //보이는 ARS
  ACT_ARS: "ARS", //음성눌렀을경우
  ACT_DIS: "DIS", //통화종료

  dataBrowser: [
    {
      string: navigator.userAgent,
      subString: "Edg",
      identity: "Edg"
    },
    {
      string: navigator.userAgent,
      subString: "Chrome",
      identity: "Chrome"
    },
    {
      string: navigator.userAgent,
      subString: "OmniWeb",
      versionSearch: "OmniWeb/",
      identity: "OmniWeb"
    },
    {
      string: navigator.vendor,
      subString: "Apple",
      identity: "Safari",
      versionSearch: "Version"
    },
    {
      prop: window.opera,
      identity: "Opera"
    },
    {
      string: navigator.vendor,
      subString: "iCab",
      identity: "iCab"
    },
    {
      string: navigator.vendor,
      subString: "KDE",
      identity: "Konqueror"
    },
    {
      string: navigator.userAgent,
      subString: "Firefox",
      identity: "Firefox"
    },
    {
      string: navigator.vendor,
      subString: "Camino",
      identity: "Camino"
    },
    {
      // for newer Netscapes (6+)
      string: navigator.userAgent,
      subString: "Netscape",
      identity: "Netscape"
    },
    {
      string: navigator.userAgent,
      subString: "MSIE",
      identity: "Explorer",
      versionSearch: "MSIE"
    },
    {
      string: navigator.userAgent,
      subString: "Gecko",
      identity: "Mozilla",
      versionSearch: "rv"
    },
    {
      // for older Netscapes (4-)
      string: navigator.userAgent,
      subString: "Mozilla",
      identity: "Netscape",
      versionSearch: "Mozilla"
    }
  ],
  dataOS: [
    {
      string: navigator.platform,
      subString: "Win",
      identity: "Windows"
    },
    {
      string: navigator.platform,
      subString: "Mac",
      identity: "Mac"
    },
    {
      string: navigator.userAgent,
      subString: "iPhone",
      identity: "iPhone/iPod"
    },
    {
      string: navigator.platform,
      subString: "Linux",
      identity: "Linux"
    }
  ]
};

Constants.install = function(Vue) {
  Vue.prototype.$CONST = Constants;
};

export default Constants;
